import { render } from "./RiceGamePage.vue?vue&type=template&id=46693fb5"
import script from "./RiceGamePage.vue?vue&type=script&lang=js"
export * from "./RiceGamePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__